export default "__VITE_ASSET__D_eKhH77__"